import { createGlobalStyle } from 'styled-components';

const BaseStyles = createGlobalStyle`
  @font-face {
  font-family: 'Nanum Gothic';
  font-style: normal;
  font-weight: 400;
  src: local('NanumGothic-Regular'),
  local('NanumGothicRegular'),
  local('NanumGothic'),
  url('/static_fonts/NanumGothic-Regular.woff2') format('woff2'),
  url('/static_fonts/NanumGothic-Regular.woff') format('woff'),
  url('/static_fonts/NanumGothic-Regular.ttf') format('truetype');
}

@font-face {
  font-family: 'Nanum Gothic';
  font-style: normal;
  font-weight: 700;
  src: local('NanumGothic Bold'),
  local('NanumGothic-Bold'),
  local('NanumGothicBold'),
  url('/static_fonts/NanumGothic-Bold.woff2') format('woff2'),
  url('/static_fonts/NanumGothic-Bold.woff') format('woff'),
  url('/static_fonts/NanumGothic-Bold.ttf') format('truetype');
}

@font-face {
  font-family: 'Noto Sans';
  font-style: normal;
  font-weight: 400;
  src: local('Noto Sans'), local('NotoSans'), local('NotoSansRegular'), local('NotoSans-Regular'),
  url('/static_fonts/NotoSans-Regular.ttf') format('truetype')
}

@font-face {
  font-family: 'Noto Sans';
  font-style: normal;
  font-weight: 700;
  src: local('Noto Sans Bold'), local('NotoSansBold'), local('NotoSans-Bold'), url('/static_fonts/NotoSans-Bold.ttf') format('truetype')
}
 

@font-face {
  font-family: 'Noto Sans JP';
  font-style: normal;
  font-weight: 400;
  src: local('Noto Sans Japanese Regular'), local('NotoSansJapanese-Regular'), local('NotoSansJapaneseRegular'), url('/static_fonts/NotoSansJP-Regular.woff2') format('woff2'),
  url('/static_fonts/NotoSansJP-Regular.woff') format('woff'),
  url('/static_fonts/NotoSansJP-Regular.otf') format('opentype');
}

@font-face {
  font-family: 'Noto Sans JP';
  font-style: normal;
  font-weight: 700;
  src: local('Noto Sans Japanese Bold'), local('NotoSansJapanese-Bold'), local('NotoSansJapaneseBold'), url('/static_fonts/NotoSansJP-Bold.woff2') format('woff2'),
  url('/static_fonts/NotoSansJP-Bold.woff') format('woff'),
  url('/static_fonts/NotoSansJP-Bold.otf') format('opentype');
}

:root {
  --font-base: 'Noto Sans', 'Noto Sans KR', Lucida Sans Unicode, sans-serif;
  --font-base-jp: 'Noto Sans JP', 'Noto Sans', Lucida Sans Unicode, sans-serif;
  --font-base-kr: 'Nanum Gothic', Lucida Sans Unicode, sans-serif;
}

/*!
 * Bootstrap Reboot v4.3.1 (https://getbootstrap.com/)
 * Copyright 2011-2020 The Bootstrap Authors
 * Copyright 2011-2020 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * Forked from Normalize.css, licensed MIT (https://github.com/necolas/normalize.css/blob/master/LICENSE.md)
 */
*,
*::before,
*::after {
  box-sizing: border-box;
}

body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #212529;
  background-color: #fff;
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

[tabindex="-1"]:focus:not(:focus-visible) {
  outline: 0 !important;
}

hr {
  margin: 1rem 0;
  color: inherit;
  background-color: currentColor;
  border: 0;
  opacity: 0.25;
}

hr:not([size]) {
  height: 1px;
}

h1, h2, h3, h4, h5, h6 {
  margin-top: 0;
  margin-bottom: 0.5rem;
  font-weight: 500;
  line-height: 1.2;
}

h1 {
  font-size: calc(1.375rem + 1.5vw);
}

@media (min-width: 1200px) {
  h1 {
    font-size: 2.5rem;
  }
}

h2 {
  font-size: calc(1.325rem + 0.9vw);
}

@media (min-width: 1200px) {
  h2 {
    font-size: 2rem;
  }
}

h3 {
  font-size: calc(1.3rem + 0.6vw);
}

@media (min-width: 1200px) {
  h3 {
    font-size: 1.75rem;
  }
}

h4 {
  font-size: calc(1.275rem + 0.3vw);
}

@media (min-width: 1200px) {
  h4 {
    font-size: 1.5rem;
  }
}

h5 {
  font-size: 1.25rem;
}

h6 {
  font-size: 1rem;
}

p {
  margin-top: 0;
  margin-bottom: 1rem;
}

abbr[title],
abbr[data-original-title] {
  text-decoration: underline;
  -webkit-text-decoration: underline dotted;
  text-decoration: underline dotted;
  cursor: help;
  -webkit-text-decoration-skip-ink: none;
  text-decoration-skip-ink: none;
}

address {
  margin-bottom: 1rem;
  font-style: normal;
  line-height: inherit;
}

ol,
ul {
  padding-left: 2rem;
}

ol,
ul,
dl {
  margin-top: 0;
  margin-bottom: 1rem;
}

ol ol,
ul ul,
ol ul,
ul ol {
  margin-bottom: 0;
}

dt {
  font-weight: 700;
}

dd {
  margin-bottom: .5rem;
  margin-left: 0;
}

blockquote {
  margin: 0 0 1rem;
}

b,
strong {
  font-weight: bolder;
}

small {
  font-size: 0.875em;
}

mark {
  padding: 0.2em;
  background-color: #fcf8e3;
}

sub,
sup {
  position: relative;
  font-size: 0.75em;
  line-height: 0;
  vertical-align: baseline;
}

sub {
  bottom: -.25em;
}

sup {
  top: -.5em;
}

a {
  color: #0d6efd;
  text-decoration: underline;
}

a:hover {
  color: #024dbc;
}

a:not([href]), a:not([href]):hover {
  color: inherit;
  text-decoration: none;
}

pre,
code,
kbd,
samp {
  font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  font-size: 1em;
}

pre {
  display: block;
  margin-top: 0;
  margin-bottom: 1rem;
  overflow: auto;
  font-size: 0.875em;
}

pre code {
  font-size: inherit;
  color: inherit;
  word-break: normal;
}

code {
  font-size: 0.875em;
  color: #d63384;
  word-wrap: break-word;
}

a > code {
  color: inherit;
}

kbd {
  padding: 0.2rem 0.4rem;
  font-size: 0.875em;
  color: #fff;
  background-color: #212529;
  border-radius: 0.2rem;
}

kbd kbd {
  padding: 0;
  font-size: 1em;
  font-weight: 700;
}

figure {
  margin: 0 0 1rem;
}

img,
svg {
  vertical-align: middle;
}

table {
  caption-side: bottom;
  border-collapse: collapse;
}

caption {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: #6c757d;
  text-align: left;
}

th {
  text-align: inherit;
  text-align: -webkit-match-parent;
}

label {
  display: inline-block;
  margin-bottom: 0.5rem;
}

button {
  border-radius: 0;
}

button:focus {
  outline: 1px dotted;
  outline: 5px auto -webkit-focus-ring-color;
}

input,
button,
select,
optgroup,
textarea {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

button,
input {
  overflow: visible;
}

button,
select {
  text-transform: none;
}

select {
  word-wrap: normal;
}

[list]::-webkit-calendar-picker-indicator {
  display: none;
}

button,
[type="button"],
[type="reset"],
[type="submit"] {
  -webkit-appearance: button;
}

button {
  cursor: pointer;
}

button:disabled {
  cursor: default;
}

::-moz-focus-inner {
  padding: 0;
  border-style: none;
}

input[type="date"],
input[type="time"],
input[type="datetime-local"],
input[type="month"] {
  -webkit-appearance: textfield;
}

textarea {
  resize: vertical;
}

fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0;
}

legend {
  float: left;
  width: 100%;
  padding: 0;
  margin-bottom: 0.5rem;
  font-size: calc(1.275rem + 0.3vw);
  line-height: inherit;
  white-space: normal;
}

@media (min-width: 1200px) {
  legend {
    font-size: 1.5rem;
  }
}

legend + * {
  clear: left;
}

::-webkit-datetime-edit-fields-wrapper,
::-webkit-datetime-edit-text,
::-webkit-datetime-edit-minute,
::-webkit-datetime-edit-hour-field,
::-webkit-datetime-edit-day-field,
::-webkit-datetime-edit-month-field,
::-webkit-datetime-edit-year-field {
  padding: 0;
}

::-webkit-inner-spin-button {
  height: auto;
}

[type="search"] {
  outline-offset: -2px;
  -webkit-appearance: textfield;
}

::-webkit-search-decoration {
  -webkit-appearance: none;
}

::-webkit-color-swatch-wrapper {
  padding: 0;
}

::-webkit-file-upload-button {
  font: inherit;
  -webkit-appearance: button;
}

output {
  display: inline-block;
}

summary {
  display: list-item;
  cursor: pointer;
}

progress {
  vertical-align: baseline;
}

[hidden] {
  display: none !important;
}

body * {
  box-sizing: border-box;
}

code, pre {
  font-family: var(--font-base-kr) !important;
}

html[lang=ko], html[lang=ko_KR] {
  body {
    font-family: var(--font-base-kr);
  }

  h1, h2, h3, h4, h5, h6 {
    font-family: var(--font-base-kr);
  }

  pre, code, .CodeMirror textarea {
    font-family: var(--font-base-kr) !important;
  }

  code, pre:not(.CodeMirror-line):not(.CodeMirror-placeholder) {
    font-family: Menlo, Monaco, Consolas, monospace !important;
  }
}

html[lang=ja], html[lang=ja_JP] {
  body {
    font-family: var(--font-base-jp);
  }

  h1, h2, h3, h4, h5, h6 {
    font-family: var(--font-base-jp);
  }

  pre, code, .CodeMirror textarea {
    font-family: var(--font-base-jp) !important;
  }

  code, pre:not(.CodeMirror-line):not(.CodeMirror-placeholder) {
    font-family: Menlo, Monaco, Consolas, monospace !important;
  }
}

html[lang=en], html[lang=en_US] {
  body {
    font-family: var(--font-base);
  }

  h1, h2, h3, h4, h5, h6 {
    font-family: var(--font-base);
  }

  pre, code, .CodeMirror textarea {
    font-family: var(--font-base) !important;
  }

  code, pre:not(.CodeMirror-line):not(.CodeMirror-placeholder) {
    font-family: Menlo, Monaco, Consolas, monospace !important;
  }
}

html, body, div[ui-view] {
  height: 100%;
  width: 100%;
  overflow: hidden;
}

body {
  color: #333;
  font-size: 13px;
  font-family: var(--font-base);
  overflow-y: hidden;
  width: 100vw;
  line-height: initial;
  padding: 0;
  margin: 0;
  min-height: 448px;
}

div {
  box-sizing: border-box;
}

h1, h2, h3, h4, h5, h6 {
  margin: 0;
  font-family: var(--font-base);
}

ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

input {
  font-size: inherit;
}

a {
  color: #125de6;
  text-decoration: none;
}

pre {
  border: 1px solid ${(props) => props.theme.colors.border};
  border-radius: 0;
  background-color: #fff;
  padding: 18px;
  margin: 0;
  white-space: pre-wrap;
}

code {
  color: #c7254e;
  background-color: #f9f2f4;
  border-radius: 4px;
  padding: 2px 4px;
  font-size: 90%;
}

pre code {
  background-color: transparent;
  font-size: inherit;
  color: inherit;
}

img {
  pointer-events: none
}

a[ng-href=""],
a[href=""] {
  text-decoration: none;
  color: #333;
  outline: none;
}

.modal-open .modal {
  display: flex !important;
}

.match {
    color: #005aff;
}

.dummy-mention-badge {
    color: #333;
    padding: 0 5px;
    display: inline-flex;
    height: 20px;
    align-items: center;
    text-decoration: none;
    max-width: 100%;
    border-radius: 20px;
    line-height: initial;
}
`;

export default BaseStyles;
